import { render, staticRenderFns } from "./EditProfissional.vue?vue&type=template&id=23d680cf"
import script from "./EditProfissional.vue?vue&type=script&lang=js"
export * from "./EditProfissional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports